module.exports = __webpack_public_path__ + "img/logo_UYS.d93fa5b2.svg";